import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { LI, UL } from '../../../AbstractElements';
import Notification from './Notification';
import { Href } from '../../../Utils/Constants';
import { RootState } from '../../../store/Store';
import { setIsSearchBarOpen } from '../../../store/reducers/Layout/LayoutReducer';
import UserWrap from './UserWrap';
import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons';

export default function HeaderRight() {
   const dispatch = useDispatch();
   const { isSearchBarOpen } = useSelector((state: RootState) => state.layout);
   const handleSearch = () => {
      dispatch(setIsSearchBarOpen(!isSearchBarOpen));
   };
   return (
      <div className="nav-right">
         <UL className="header-right simple-list flex-row">
            <LI className="search d-lg-none d-flex">
               <a href={Href} onClick={handleSearch}>
                  <SvgIcon iconId="Search" />
               </a>
            </LI>
            {/*<Notification />*/}
            <UserWrap />
         </UL>
      </div>
   );
}
